
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/college-boxes-storage",
      function () {
        return require("private-next-pages/college-boxes-storage/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/college-boxes-storage"])
      });
    }
  